export default __webpack_public_path__ + "static/media/tools.1898f26a.png";